import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { ModalEntryPoint } from '../shared/modal-entry-point';
import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './paidToTwcModal.entrypoint';

export function PaidToTwcModal(): React.JSX.Element {
	const { formatMessage } = useIntl();
	const { cloudId, entitlementId } = useEditionAwareness();
	const entryPointParams = useMemo(
		() => ({
			context: entitlementId
				? {
						tenantId: cloudId,
						useCase: 'bundleableEntitlements',
						custom: { entitlementIds: [entitlementId] },
					}
				: null,
		}),
		[cloudId, entitlementId],
	);
	const modalProps = useMemo(
		() => ({
			width: 968,
			height: '640px',
			shouldScrollInViewport: false,
			label: formatMessage({
				id: '@atlassian/edition-awareness.dialog.paid-to-twc.label',
				defaultMessage: 'Teamwork Collection plan comparison',
				description: 'Accessible name for the Teamwork Collection comparison dialog.',
			}),
		}),
		[formatMessage],
	);

	return (
		<ModalEntryPoint
			modalProps={modalProps}
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
